const OBJECT_URL_REVOKE_DELAY_MS = 1000;

// A API pode devolver application/pdf ou application/x-zip. Derivamos a extensão
// do content-type do blob para o arquivo baixado abrir corretamente no SO.
const EXTENSION_BY_TYPE = {
  "application/pdf": "pdf",
  "application/zip": "zip",
  "application/x-zip": "zip",
  "application/x-zip-compressed": "zip",
};

const withExtension = (file, baseName) => {
  const extension = EXTENSION_BY_TYPE[file?.type];

  return extension ? `${baseName}.${extension}` : baseName;
};

const downloadBlob = (file, baseName) => {
  const fileName = withExtension(file, baseName);

  if (window.navigator?.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(file, fileName);
    return;
  }

  const objectUrl = URL.createObjectURL(file);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = fileName;

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  setTimeout(() => URL.revokeObjectURL(objectUrl), OBJECT_URL_REVOKE_DELAY_MS);
};

export default downloadBlob;
